module.exports = __webpack_public_path__ + "img/2318.00027b34.png";